import script from "./ComparacionCalificacionesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComparacionCalificacionesView.vue?vue&type=script&setup=true&lang=ts"

import "./ComparacionCalificacionesView.vue?vue&type=style&index=0&id=3038cbcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3038cbcc"]])

export default __exports__